import { render, staticRenderFns } from "./page_home.vue?vue&type=template&id=49714206&scoped=true"
import script from "./page_home.vue?vue&type=script&lang=js"
export * from "./page_home.vue?vue&type=script&lang=js"
import style0 from "./page_home.vue?vue&type=style&index=0&id=49714206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49714206",
  null
  
)

export default component.exports